(function () {
  'use strict';
  angular.module('MktzapApp.Factories')
	    .factory('IntegrationsConfigsService', IntegrationsConfigsService);

  IntegrationsConfigsService.$inject = ['$resource'];

  function IntegrationsConfigsService ($resource) {
    return $resource('', {}, {
      saveConfig: { url: apiUrl + '/integrations-configs', method: 'POST', params: {}, isArray: false },
      getConfigs: { url: apiUrl + '/integrations-configs', method: 'GET', params: {}, isArray: false },
      deleteConfigs: { url: apiUrl + '/integrations-configs', method: 'DELETE', params: {}, isArray: false }
    });
  }
})();
